import React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';

function SearchBar(props) {
  const {
    value = '',
    onChange,
    placeholder = '검색',
    className = 'bg-white px-4 py-2.5',
    searchBarclassName = 'bg-slate-100',
    inputClassName = '',
  } = props;

  return (
    <div className={`flex-shrink-0 ${className}`.trim()}>
      <label className="relative flex h-12 w-full flex-col">
        <div
          className={`flex h-full w-full flex-1 items-stretch rounded-xl bg-slate-100 ${searchBarclassName}`}
        >
          <div className="flex items-center justify-center pl-4 text-slate-400">
            <SearchIcon className="!text-xl" />
          </div>
          <input
            type="search"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`flex h-full w-full min-w-0 flex-1 border-none bg-transparent px-3 text-base font-normal placeholder:text-slate-400 focus:ring-0 focus:outline-none ${inputClassName}`.trim()}
          />
        </div>
      </label>
    </div>
  );
}

export default SearchBar;
